import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const VerifyForgotPassword = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePassword = () => {
    if (password.length < 10) {
      return "Password must be at least 10 characters long.";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password must include at least one uppercase letter.";
    }
    if (!/[a-z]/.test(password)) {
      return "Password must include at least one lowercase letter.";
    }
    if (!/[0-9]/.test(password)) {
      return "Password must include at least one number.";
    }
    if (!/[!@#$%^&*]/.test(password)) {
      return "Password must include at least one special character (!@#$%^&*).";
    }
    if (password !== confirmPassword) {
      return "Passwords do not match.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    const validationError = validatePassword();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    setIsLoading(true);

    const api_url = process.env.REACT_APP_API_URL;
    const requestBody = {
      code: code,
      password: password,
    };

    try {
      const response = await fetch(`${api_url}/auth:reset_password_change`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.errorObject?.message || "Failed to reset password.");
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      if (data.success) {
        window.location.href = "emalpha://open"
        setSuccessMessage("Your password has been successfully reset. You can now log in.");
      } else {
        setErrorMessage(data.errorObject?.message || "Failed to reset password.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please check your connection and try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!code) {
      setErrorMessage("Invalid or missing reset code.");
    }
  }, [code]);

  return (
    <div
      className="d-flex h-100 w-100 justify-content-center align-items-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="bg-white rounded-4 p-5 d-flex flex-column shadow-lg"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        {successMessage ? (
          <div className="text-center">
            <h4 className="text-success mb-3">Password Reset Successful</h4>
            <p className="text-muted">{successMessage}</p>
            <button
              className="btn btn-primary mt-3 fw-bold"
              onClick={() => {
                window.location.href = "/login";
              }}
            >
              Go to Login
            </button>
          </div>
        ) : (
          <>
            <h3 className="text-start mb-4 text-primary">Reset Your Password</h3>
            <p
              className="text-start text-muted mb-4"
              style={{ fontSize: "14px" }}
            >
              Enter a new password to reset your account.
            </p>
            {errorMessage && (
              <div className="alert alert-danger text-center" role="alert">
                {errorMessage}
              </div>
            )}
            <form
              onSubmit={handleSubmit}
              className="d-flex flex-column form-floating flex-fill mb-3"
            >
              <div className="form-floating flex-fill mb-3">
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <label htmlFor="password" className="form-label">
                  New Password
                </label>
              </div>
              <div className="form-floating flex-fill mb-3">
                <input
                  type="password"
                  id="confirmPassword"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
              </div>
              <button
                type="submit"
                className="btn btn-primary w-100 mt-2 fw-bold"
                disabled={!password.trim() || !confirmPassword.trim() || isLoading}
              >
                {isLoading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyForgotPassword;
